import { Item, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  AnchorTargetParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';

export type S04SiteSearchProps = RenderingProps<
  {
    NoResultsText?: RichTextField;
    ScopeSearchToSection?: Item[];
  },
  {
    NumberOfSearchResultsPerPage?: string;
  } & TranslationOptionsParams &
    AnchorTargetParams
>;
